//
//
//
//
//
//

export default {
    mounted() {
        let mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

        mapboxgl.accessToken = 'pk.eyJ1Ijoiam9obnNlZXJvdyIsImEiOiJjam1sdGZ2dmIwYnZqM2txbXQ5eWF1eWl2In0.aGi6GWAlmAg4xdouEr1aZQ';
        const map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/johnseerow/cjmlu2l0wc1532sozr3zdcpee',
            center: [7.5261436, 47.2017425],
            zoom: 16,
        });

        map.on("load", function () {
            /* Image: An image is loaded and added to the map. */
            map.loadImage("/app/themes/lineabertoli/dist/images/marker.png", function(error, image) {
                if (error) throw error;
                map.addImage("custom-marker", image);
                /* Style layer: A style layer ties together the source and image and specifies how they are displayed on the map. */
                map.addLayer({
                    id: "markers",
                    type: "symbol",
                    /* Source: A data source specifies the geographic coordinate where the image marker gets placed. */
                    source: {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features:[{"type":"Feature","geometry":{"type":"Point","coordinates":["7.5261436","47.2017425"]}}]}
                    },
                    layout: {
                        "icon-image": "custom-marker",
                    }
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/vue/map-box.vue